/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2023-01-31 14:11:01
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2026-01-30 10:23:30
 * @Description: app入口文件
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './unit/lng'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
